// extracted by mini-css-extract-plugin
export default {"page":"SuspireTerminalLayout_page__QBxq3","headerShell":"SuspireTerminalLayout_headerShell__x+RXK","outletShell":"SuspireTerminalLayout_outletShell__KERMo"};